import { useCallback, useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useAirModal } from '@air/provider-modal';

import { KeyboardShortcutsInfoModal } from '~/components/AssetModalV2/Content/Footer/components/KeyboardShortcuts/KeyboardShortcutsInfoModal';

/**
 * Hook to manage the keyboard shortcuts info modal.
 * Provides toggle functionality via cmd+/ keyboard shortcut.
 */
export const useKeyboardShortcutsModal = () => {
  const [showKeyboardShortcutsInfoModal, hideKeyboardShortcutsInfoModal] = useAirModal(KeyboardShortcutsInfoModal);
  const isModalOpenRef = useRef(false);

  const toggleKeyboardShortcutsModal = useCallback(() => {
    if (isModalOpenRef.current) {
      hideKeyboardShortcutsInfoModal();
      isModalOpenRef.current = false;
    } else {
      showKeyboardShortcutsInfoModal();
      isModalOpenRef.current = true;
    }
  }, [showKeyboardShortcutsInfoModal, hideKeyboardShortcutsInfoModal]);

  useHotkeys('meta+/', toggleKeyboardShortcutsModal, {
    preventDefault: true,
  });

  return {
    showKeyboardShortcutsModal: showKeyboardShortcutsInfoModal,
    hideKeyboardShortcutsModal: hideKeyboardShortcutsInfoModal,
    toggleKeyboardShortcutsModal,
  };
};
